import { Box, Stack } from "@mui/material";
import SubdirectoryArrowRightRoundedIcon from "@mui/icons-material/SubdirectoryArrowRightRounded";
import React from "react";
import theme from "Theme/AppTheme";
import { ConversationComment } from "services/ConversationService";

type RepliesListProps = {
    replies: ConversationComment[];
    renderCommentContent: (
        comment: ConversationComment,
        options: { showTimestamp: boolean; editComposer?: React.ReactNode },
    ) => React.ReactNode;
    activeEditCommentId: string | null;
    editComposer: React.ReactNode;
};

const RepliesList = React.memo(
    ({
        replies,
        renderCommentContent,
        activeEditCommentId,
        editComposer,
    }: RepliesListProps) => (
        <Stack spacing={1.5}>
            {replies.map((reply) => (
                <Box
                    key={reply.id}
                    id={reply.id ? `comment-${reply.id}` : ""}
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        paddingLeft: 3,
                    }}
                >
                    <SubdirectoryArrowRightRoundedIcon
                        sx={{
                            color: theme.palette.gray[400],
                            fontSize: "18px",
                            marginTop: "2px",
                            flexShrink: 0,
                        }}
                    />
                    <Box sx={{ flex: 1 }}>
                        {renderCommentContent(reply, {
                            showTimestamp: false,
                            editComposer:
                                reply.id === activeEditCommentId
                                    ? editComposer
                                    : null,
                        })}
                    </Box>
                </Box>
            ))}
        </Stack>
    ),
);

export default RepliesList;
